import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

// redux imports
import { updateCategory } from "../../../redux/actions/categoriesActions";

// Components imports
import InputField from "../../common/InputField";
import Button from "../../common/Button";

// Icons imports
import { RiDeleteBin5Line } from "react-icons/ri";

// Scss imports
import css from "./CategoryItem.module.scss";
interface CategoryItemProps {
  number: number;
  nameText?: string;
  onNameTextInputValueChange?: Function;
  inputNameTextError?: string;
  icon: any;
  deleteIcon: boolean;
  deleteCategoryFunction?: any;
  id?: string;
  sendData: any;
  handleChange: any;
  baseNumber?: any;
  name?: string;
  shelfLife?: any;
  newItem?: boolean;
  setIsClicked?: any;
  category?: any;
  showAllCategories?: boolean;
  setUserInput?: any;
}

const CategoryItem: React.FC<CategoryItemProps> = ({
  number,
  nameText,
  onNameTextInputValueChange,
  inputNameTextError,
  shelfLife,
  name,
  baseNumber,
  icon,
  deleteIcon,
  deleteCategoryFunction,
  id,
  sendData,
  handleChange,
  newItem,
  setIsClicked,
  category,
  showAllCategories,
  setUserInput
}) => {
  const dispatch = useDispatch();
  const addCategoryError = useSelector(
    (state: any) => state.allCategories.addCategoryError
  );

  useEffect(() => {
    if (newItem === false) {
      const elementBaseNumber: any = document.getElementById(
        category.id + category.baseNumber
      );
      elementBaseNumber.value = category.baseNumber;

      const elementName: any = document.getElementById(
        category.id + category.name
      );
      elementName.value = category.name;

      const elementShelfLife: any = document.getElementById(
        category.id + category.shelfLife
      );
      elementShelfLife.value = category.shelfLife;
    }
  }, []);

  const clean = (obj) => {
    for (var propName in obj) {
      if (
        obj[propName] === "" ||
        //obj[propName] === 0 ||
        obj[propName] === null ||
        obj[propName] === undefined
      ) {
        delete obj[propName];
      }
    }
    return obj;
  };

  // Set category to inactive
  const makeCategoryInactive = (id) => {
    dispatch(
      updateCategory(
        clean({
          active: false
        }),
        id
      )
    );
  };

  return (
    <>
      <div className={css.container}>
        {newItem && <p className={css.errorText}> {addCategoryError}</p>}
        <div className={css.item} data-id={id}>
          <p className={css.number}>{number}</p>

          {/* Form */}
          <form className={css.form} data-id={id}>
            <InputField
              label="Основни број"
              name="baseNumber"
              id={!newItem ? category.id + category.baseNumber : "baseNumber"}
              type="number"
              //placeholder={newItem === false ? category.baseNumber : ""}
              value={baseNumber}
              handleChange={handleChange}
              handleOnFocus={(e: any) => (e.target.placeholder = "")}
              handleOnBlur={(e: any) =>
                (e.target.placeholder =
                  newItem === false ? category.baseNumber : "")
              }
              rowFormGroup={true}
              //onInputHandler={onInputName}
              labelClass="marginLabel"
              rowFormGroupCenter={true}
              //onClick={setIsClicked(true)}
              inputType="category"
            />

            <InputField
              label="Име категорије"
              name="name"
              id={!newItem ? category.id + category.name : "name"}
              type="text"
              //placeholder={newItem === false ? category.name : ""}
              value={name}
              handleChange={handleChange}
              handleOnFocus={(e: any) => (e.target.placeholder = "")}
              handleOnBlur={(e: any) =>
                (e.target.placeholder = newItem === false ? category.name : "")
              }
              rowFormGroup={true}
              //onInputHandler={onInputSurname}
              labelClass="marginLabel"
              rowFormGroupCenter={true}
              inputType="category"
            />
            <InputField
              label="Рок чувања"
              name="shelfLife"
              id={!newItem ? category.id + category.shelfLife : "shelfLife"}
              type="text"
              placeholder={newItem === false ? category.shelfLife : ""}
              value={shelfLife}
              handleChange={handleChange}
              handleOnFocus={(e: any) => (e.target.placeholder = "")}
              handleOnBlur={(e: any) =>
                (e.target.placeholder =
                  newItem === false ? category.shelfLife : "")
              }
              rowFormGroup={true}
              //errorText={errorNationalIdText}
              //onInputHandler={onInputNationalId}
              labelClass="marginLabel"
              rowFormGroupCenter={true}
              inputType="category"
            />

            {/* Save/edit and delete buttons */}
            {!showAllCategories && (
              <Button
                icon={icon}
                onButtonClickHandler={sendData}
                style={{
                  borderRadius: "5rem",
                  marginLeft: "2rem",
                  maxHeight: "6rem"
                }}
                //refButton={refPrevButton}
                //disabledButton={disabledPrevButton}
                //hidden={hiddenPrev}
              />
            )}
            {deleteIcon && !showAllCategories && (
              <Button
                icon={<RiDeleteBin5Line color="#982d8f" fontSize="2.3rem" />}
                onButtonClickHandler={() => makeCategoryInactive(id)}
                style={{
                  borderRadius: "5rem",
                  marginLeft: "2rem",
                  maxHeight: "6rem"
                }}
                //refButton={refPrevButton}
                //disabledButton={disabledPrevButton}
                //hidden={hiddenPrev}
              />
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default CategoryItem;
